<template>
  <div class="container">
    <el-breadcrumb separator=">" class="title">
      <el-breadcrumb-item :to="{ path: '/student_list/1' }">学员管理</el-breadcrumb-item>
      <el-breadcrumb-item>学员详情</el-breadcrumb-item>
    </el-breadcrumb>
    <el-row :gutter="10" class="info-wrapper">
      <el-col :span="8" style="padding-left: 0">
        <div class="grid-content">
          <el-image :src="cert.stuPhoto" lazy class="avatar"></el-image>
          <el-form ref="form" disabled :model="cert" label-width="100px">
            <el-form-item label="学员姓名">
              <el-input v-model="cert.stuName"></el-input>
            </el-form-item>
            <el-form-item label="证书类型">
              <el-input v-model="cert.certType"></el-input>
            </el-form-item>
            <el-form-item label="手机号">
              <el-input v-model="cert.stuPhone"></el-input>
            </el-form-item>
            <el-form-item label="学校名称">
              <el-input v-model="cert.schoolName"></el-input>
            </el-form-item>
            <el-form-item label="证书状态">
              <el-input v-model="cert.statusDesc"></el-input>
            </el-form-item>
          </el-form>
        </div>
      </el-col>
      <el-col :span="8" style="padding-left: 0">
        <div class="grid-content">
          <div class="avatar">&nbsp;</div>
          <el-form ref="form" disabled :model="cert" label-width="100px">
            <el-form-item label="英文名">
              <el-input v-model="cert.stuNameFirst"></el-input>
            </el-form-item>
            <el-form-item label="雪场">
              <el-input v-model="cert.skiResort"></el-input>
            </el-form-item>
            <el-form-item label="教练">
              <el-input v-model="cert.insName"></el-input>
            </el-form-item>
            <el-form-item label="发证时间">
              <el-input v-model="cert.entryTime"></el-input>
            </el-form-item>
            <el-form-item label="收货类型">
              <el-input v-model="cert.receiveTypeDesc"></el-input>
            </el-form-item>
          </el-form>
        </div>
      </el-col>
    </el-row>
    <div class="info-title">发货信息</div>
    <el-row :gutter="10" class="info-wrapper">
      <el-col :span="13">
        <el-form ref="form" disabled label-width="100px">
          <el-form-item label="收件地址">
            <el-input v-model="addressStr"></el-input>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="4">
        <div class="grid-content">
          <el-button
            type="primary"
            v-if="cert.status===1"
            v-clipboard:copy="addressStr"
            v-clipboard:success="_copyAddress"
            v-clipboard:error="_copyError"
          >复制</el-button>
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="10" class="express-wrapper" v-if="cert.status===1">
      <el-col :span="4" style="padding-left: 0">
        <div class="grid-content">
          <el-select v-model="expressCompany" clearable placeholder="快递公司">
            <el-option
              v-for="item in companyOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
      </el-col>
      <el-col :span="1">&nbsp;</el-col>
      <el-col :span="6" style="padding-left: 0">
        <div class="grid-content">
          <el-input placeholder="" v-model="expressNo">
            <template slot="prepend">快递单号</template>
          </el-input>
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="10" style="margin-top: 20px;" v-if="cert.status===1">
      <el-col :span="2">&nbsp;</el-col>
      <el-col :span="3" style="padding-left: 0">
        <div class="grid-content">
          <el-button type="primary" @click="_certExpress" :loading="loading">发货</el-button>
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="10" class="info-wrapper" v-if="cert.status===2">
      <el-col :span="8">
        <el-form ref="form" disabled :model="expressInfo" label-width="100px">
          <el-form-item label="快递公司">
            <el-input v-model="expressInfo.expressCoDesc"></el-input>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="8">
        <el-form ref="form" disabled :model="expressInfo" label-width="100px">
          <el-form-item label="快递单号">
            <el-input v-model="expressInfo.expressNo"></el-input>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="8">
        <el-form ref="form" disabled :model="expressInfo" label-width="100px">
          <el-form-item label="发货时间">
            <el-input v-model="expressInfo.entryTime"></el-input>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <div class="info-title">&nbsp;</div>
  </div>
</template>

<script type="text/ecmascript-6">
  import { listType } from '../common/js/config';
  import { getCertDetail, certExpress } from '@/api/cert';
  import { mapGetters, mapActions } from 'vuex';

  export default {
    data() {
      return {
        addressStr: '',
        expressInfo: {},
        companyOptions: [{
          value: 'sf',
          label: '顺丰'
        }, {
          value: 'db',
          label: '德邦'
        }, {
          value: 'yt',
          label: '圆通'
        }],
        expressCompany: '',
        expressNo: '',
        loading: false
      };
    },
    created() {
      this._getCertDetail();
    },
    methods: {
      _getCertDetail() {
        getCertDetail(this.user.userId, this.$route.params.id).then((res) => {
          const { addressStr, expressInfo } = res;
          this.addressStr = addressStr;
          this.expressInfo = expressInfo;
        });
      },
      _certExpress() {
        if (!this.expressCompany) {
          this.$message.warning('请选择快递公司');
          return;
        }
        if (!this.expressNo) {
          this.$message.warning('请输入快递号');
          return;
        }
        this.loading = true;
        certExpress(this.user.userId, [this.cert.id], this.expressCompany, this.expressNo).then((res) => {
          this.loading = false;
          if (res.rspCode === 0) {
            const { expressInfo } = res;
            this.expressInfo = expressInfo;
            let _cert = Object.assign({}, this.cert, {
              status: 2,
              statusDesc: '已发货',
            });
            this.setItem({
              item: _cert,
              type: listType.CERT
            });
          } else {
            this.$message.error(res.rspDesc);
          }
        }).catch(() => {
          this.$message.error('系统异常，请重试！');
          this.loading = false;
        });
      },
      _copyAddress() {
        this.$message.success('复制成功');
      },
      _copyError() {
        this.$message.error('复制失败');
      },
      ...mapActions([
        'setItem'
      ]),
    },
    computed: {
      ...mapGetters([
        'user',
        'cert'
      ])
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus" rel="stylesheet/stylus">
  .container
    height: 100%;
    .title
      margin-bottom: 20px;
    .info-title
      margin-top: 20px;
      margin-bottom: 20px;
      font-weight: 400;
      font-size: 14px;
      color: #606266;
      cursor: text;
    .info-wrapper
      padding: 20px 20px 0 0;
      margin: 0 0 10px 0 !important;
      background: #fff;
      .avatar
        width: 174px;
        height: 216px;
        margin: 0 0 20px 20px;
        .image-slot
          height: 100%;
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
    .express-wrapper
      padding: 20px;
      background: #fff;
</style>